import { TableColumnsType } from "antd";
import { AppointmentTimeSlotPlan } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotPlan.interface";
import { Link } from "react-router-dom";
import { Button } from "@rumbledirect/ui";
import { EyeOutlined } from "@ant-design/icons";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";

export const appointmentTimeSlotPlanColumns: TableColumnsType<AppointmentTimeSlotPlan> =
  [
    {
      title: "Naam",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: AppointmentTimeSlotPlan) => (
        <Link to={`/appointment-time-slots/plans/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "Beschrijving",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Herstellers",
      dataIndex: "servicePartners",
      key: "servicePartners",
      render: (servicePartners: ServicePartner[] | undefined) =>
        servicePartners?.length ?? 0,
    },
    {
      title: "Opdrachtgever",
      dataIndex: "company",
      key: "company",
      render: (company: any) => company?.fullName || "-",
    },
    {
      title: "Dealer",
      dataIndex: "dealership",
      key: "dealership",
      render: (dealership: any) => dealership?.fullName || "-",
    },
    {
      title: "Aantal tijdsloten",
      dataIndex: "amountOfPlanItems",
      key: "amountOfPlanItems",
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: unknown, record: AppointmentTimeSlotPlan) => (
        <Link to={`/appointment-time-slots/plans/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];
